import React from "react";
import { useLanguage } from "../../i18n";

const ProblemSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="problema" className="py-24 md:py-32 bg-[#050505]" data-testid="problem-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 animate-fade-in-up">
          {t('problem.title')}{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
            {t('problem.titleHighlight')}
          </span>
        </h2>
        <p className="text-lg md:text-xl text-gray-400 leading-relaxed mb-6">
          {t('problem.description')}
        </p>
        <p className="text-xl md:text-2xl text-white font-medium">
          {t('problem.conclusion')}
        </p>
      </div>
    </section>
  );
};

export default ProblemSection;
